import {escapeForJsContext} from '@utils/stringEscape';
import {BreadcrumbList, ListItem} from 'schema-dts';

import {BreadcrumbsBackstackItem} from './types';

export const getJsonLdForBreadcrumbs = ({
  backstack,
  domain,
}: {
  backstack: BreadcrumbsBackstackItem[];
  domain: string;
}): BreadcrumbList => ({
  '@type': 'BreadcrumbList',
  itemListElement: backstack.map(
    ({path, title}, index): ListItem => ({
      '@type': 'ListItem',
      name: escapeForJsContext(title),
      position: index + 1,
      item: path.startsWith('https://')
        ? path
        : `${domain}${path === '/' ? '' : path}`,
    }),
  ),
});
